import {remCalc} from '_themeUtils'
import sizes from '../primitives/sizes'

const icon = {
    xs: sizes[3.5],
    sm: sizes[4],
    md: sizes[5],
    lg: sizes[6],
    xl: sizes[8],
    7: sizes[7],
    'tile-button': {base: sizes[4], lg: sizes[4.5]},
    xxl: sizes[12],
}

const button = {
    xs: remCalc(176),
    sm: remCalc(272),
    md: remCalc(343),
    none: 'none',
}

const input = {
    height: sizes[13.5],
}

export {icon, button, input}
